import { render, staticRenderFns } from "./iconSettings.vue?vue&type=template&id=4f40a68d&scoped=true&"
import script from "./iconSettings.vue?vue&type=script&lang=js&"
export * from "./iconSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f40a68d",
  null
  
)

export default component.exports